// extracted by mini-css-extract-plugin
export default {"SidebarNavSection":"yGRRGkZh"};